
const formatPhoneWithPrefix = (value) => {
  // Extract just the digits after +1
  const match = value.match(/^\+1(\d{0,10})/);
  if (!match) return '+1';
  
  const digits = match[1];
  
  if (digits.length === 0) return '+1';
  if (digits.length <= 3) return `+1 (${digits}`;
  if (digits.length <= 6) return `+1 (${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `+1 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
};

const formatPhoneNumber = (value) => {
  // Remove all non-digits except +
  const cleaned = value.replace(/[^\d+]/g, '');
  
  // If user is typing and doesn't start with +1, add it
  if (!cleaned.startsWith('+1') && cleaned.length > 0) {
    const digits = cleaned.replace(/\+/g, '');
    if (digits.length <= 10) {
      return formatPhoneWithPrefix('+1' + digits);
    }
  }
  
  // If it already starts with +1, format it
  if (cleaned.startsWith('+1')) {
    return formatPhoneWithPrefix(cleaned);
  }
  
  // Default case - return +1 prefix
  return '+1';
};


const sanitizePhone = (value) => {
  if (!value) return '+1';
  return formatPhoneNumber(value);
};


const getRawPhoneDigits = (formattedPhone) => {
  if (!formattedPhone) return '';
  
  // Remove +1 prefix and extract all digits
  const digits = formattedPhone.replace(/^\+1\s*/, '').replace(/\D/g, '');
  return digits;
};


const isValidPhoneNumber = (formattedPhone) => {
  const digits = getRawPhoneDigits(formattedPhone);
  return digits.length === 10;
};

const handlePhoneKeyDown = (e) => {
  // Allow backspace, delete, tab, escape, enter
  if ([8, 9, 27, 13, 46].indexOf(e.keyCode) !== -1 ||
      // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
      (e.keyCode === 65 && e.ctrlKey === true) ||
      (e.keyCode === 67 && e.ctrlKey === true) ||
      (e.keyCode === 86 && e.ctrlKey === true) ||
      (e.keyCode === 88 && e.ctrlKey === true) ||
      // Allow home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)) {
    return;
  }
  // Ensure that it is a number and stop the keypress
  if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
    e.preventDefault();
  }
};


const createPhoneChangeHandler = (formik, fieldName) => {
  return (e) => {
    const value = e.target.value;
    const formatted = sanitizePhone(value);
    formik.setFieldValue(fieldName, formatted);
  };
};

// Enhanced sanitizers object with phone formatter
const enhancedSanitizers = {
  // Name fields: letters and single spaces only
  name: (value) => {
    if (!value) return '';
    return value
      .replace(/^\s+/, '')           // Remove leading spaces
      .replace(/\s{2,}/g, ' ')       // Replace multiple spaces with single space
      .replace(/[^a-zA-Z\s]/g, '');  // Only letters and spaces
  },

  // Phone: format to +1 (123) 456-7890
  phone: (value) => {
    return sanitizePhone(value);
  },

  // Email: lowercase and trim
  email: (value) => {
    if (!value) return '';
    return value
      .toLowerCase()                 // Convert to lowercase
      .trim();                       // Remove leading/trailing spaces
  },

  // General text: trim only
  text: (value) => {
    if (!value) return '';
    return value.trim();
  },

  // Address: allow all characters but prevent leading spaces and multiple consecutive spaces
  address: (value) => {
    if (!value) return '';
    return value
      .replace(/^\s+/, '')           // Remove leading spaces
      .replace(/\s{2,}/g, ' ');      // Replace multiple spaces with single space
  }
};

// Export all functions
export {
  formatPhoneNumber,
  formatPhoneWithPrefix,
  sanitizePhone,
  getRawPhoneDigits,
  isValidPhoneNumber,
  handlePhoneKeyDown,
  createPhoneChangeHandler,
  enhancedSanitizers
};

// Default export
export default formatPhoneNumber;